export const sanitizeDocument = (document: string | undefined): string => {
  return (document || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
};

export const isCnpjLikeSanitizedDocument = (sanitized: string): boolean => {
  return /[A-Z]/.test(sanitized) || sanitized.length > 11;
};

export const isCnpjLikeDocument = (document: string | undefined): boolean => {
  return isCnpjLikeSanitizedDocument(sanitizeDocument(document));
};
